import { PLATFORM } from "../api/ProjectAPI.types";

import type { Platform } from "../api/ProjectAPI.types";

const isPlatformTV = (platform: Platform): boolean =>
  platform === PLATFORM.TVOS ||
  platform === PLATFORM.FIRE_TV ||
  platform === PLATFORM.ANDROID_TV;

export default isPlatformTV;
